import { useQueryClient } from '@tanstack/react-query'

import {
    GetAllClientIdentityApisQueryResponse,
    getAllClientIdentityApisQueryKey,
    useDeleteClientIdentityApi as useDeleteClientIdentityApiTQ,
} from '@/gen/publicApi'

import { useToast } from '@/components/toast/useToast'

const useDeleteClientIdentityApi = (clientCode, apiKeyId) => {
    const { toast } = useToast()
    const queryClient = useQueryClient()
    const clientDeleteMutator = useDeleteClientIdentityApiTQ(clientCode, apiKeyId)

    const onDelete = () => {
        const listKey = getAllClientIdentityApisQueryKey(clientCode)
        // @ts-expect-error - kubb codegen
        clientDeleteMutator.mutate(undefined, {
            onSettled: () => {
                const previous = queryClient.getQueryData(listKey)
                queryClient.setQueryData(listKey, (data: GetAllClientIdentityApisQueryResponse | undefined) =>
                    data
                        ? {
                              ...data,
                              data: data.data?.filter(key => key.id !== apiKeyId),
                          }
                        : undefined,
                )
                return { previous }
            },
            onError: (err, _, context: any) => {
                console.error('Failed to delete API key', err)
                toast({
                    variant: 'destructive',
                    title: 'Delete failed!',
                    description: `API deletion failed, please try again`,
                })
                queryClient.setQueryData(listKey, context.previous)
            },
        })
    }

    return { onDelete }
}

export default useDeleteClientIdentityApi
